import { NiaOpportunityPeerGrowthBenchmark } from "../../services/interfaces/INiaOpportunity";

export const NIAOpportunityLabels = {
  NIAOpportunityTitle: "NIA Benchmarking",
  previousSpendColumnField: "spend",
};

export const NIAOpportunityTableHeaders = [
  {
    field: "vendor",
    header: "Supplier",
  },
  {
    field: "spend",
    header: "Spend",
  },
  // {
  //   field: "contract_end",
  //   header: "Contract End",
  // },
  {
    field: "current_rebate",
    header: "Effective Rebate",
  },
  {
    field: "peer_rebate",
    header: "Peer Rebate",
  },
  {
    field: "opportunity",
    header: "Opportunity",
  },
];

export const GrowthPerecentageHeaders = [
  {
    field: "vendor",
    header: "Supplier",
  },
  {
    field: "0%",
    header: "0%",
  },
  {
    field: "100%",
    header: "100%",
  },
  {
    field: "102.5%",
    header: "102.5%",
  },
  {
    field: "105%",
    header: "105%",
  },
  {
    field: "107.5%",
    header: "107.5%",
  },
  {
    field: "110%",
    header: "110%",
  },
  {
    field: "112.5%",
    header: "112.5%",
  },
  {
    field: "115%",
    header: "115%",
  },
  {
    field: "117.5%",
    header: "117.5%",
  },
  {
    field: "120%",
    header: "120%",
  },
  {
    field: "125%+",
    header: "125%+",
  },
];
